import { DashboardService } from "services";

import DashboardCalendarSection from "../shared/DashboardCalendarSection";

interface CalendarSectionProps {
  className?: string;
  compact?: boolean;
  selectedAgentIds?: number[] | null;
}

const CalendarSection = ({
  className,
  compact = false,
  selectedAgentIds,
}: CalendarSectionProps) => (
  <DashboardCalendarSection
    className={className}
    compact={compact}
    loadCalendar={DashboardService.getTeamLeadCalendar}
    selectedAgentIds={selectedAgentIds}
  />
);

export default CalendarSection;
